import { render } from "./confirmation.vue?vue&type=template&id=53fe3ff8"
import script from "./confirmation.vue?vue&type=script&lang=js"
export * from "./confirmation.vue?vue&type=script&lang=js"
script.render = render

export default script